import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/types';
import { useMemo } from 'react';
import { CurrencyNameEnum } from 'shared/enums/currency-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface CurrencyDataInterface {
  caption: CurrencyNameEnum;
  id: CurrencyEnum;
}
export const useCurrencyData = () => {
  const $ = _c(3);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.values(CurrencyEnum);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t0.map(cur => ({
      id: cur,
      caption: t(CurrencyNameEnum[cur])
    }));
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/**
 * Captions for a known subset of currencies — the ones a statistics response actually reports.
 * Stays `undefined` while the subset is unknown so a select keeps its loading state instead of
 * rendering an empty list.
 */
export const useCurrencySubsetData = currencies => {
  const $ = _c(3);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== currencies || $[1] !== t) {
    t0 = currencies?.map(cur => ({
      id: cur,
      caption: t(CurrencyNameEnum[cur])
    }));
    $[0] = currencies;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};